var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"appRef",attrs:{"id":"app"}},[_c('router-view'),(_vm.isShowModal&&_vm.shouldShowModal)?_c('GlobalModal',{on:{"close":_vm.closeModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }